import { gql } from 'graphql-request';
import { CART_FRAGMENT } from './fragments';

/**
 * Retrieve a cart by its ID.
 */
export const CART = gql`
  query getCart($cartId: ID!, $country: CountryCode) @inContext(country: $country) {
    cart(id: $cartId) {
      ... on Cart {
        ...cartFragment
      }
    }
  }
  ${CART_FRAGMENT}
`;

/**
 * Returns an array of line item quantities in an existing cart
 */
export const CART_LINE_ITEMS_COUNTS = gql`
  query getLineItemsCounts($cartId: ID!, $country: CountryCode) @inContext(country: $country) {
    cart(id: $cartId) {
      ... on Cart {
        lines(first: 250) {
          quantity
        }
      }
    }
  }
`;

export default {};
